import * as React from 'react';
import {useEffect, useState} from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useTitle} from '../dashboard/TitleContext';
import {useSnackbar} from '../../util/SnackbarProvider';
import roleService from "../../services/RoleService";
import TableCell from "@mui/material/TableCell";
import {Button, Checkbox, CircularProgress} from "@mui/material";
import {ROLES} from "../../util/Const";

const rows = [
    {id: "SUB_STORAGE_READER", name: "Alraktár Megtekintés"},
    {id: "SUB_STORAGE_EDITOR", name: "Alraktár Szerkesztés"},
    {id: "PROJECT_BUDGET", name: "Projekt Pénzügy Kezelés"},
    {id: "PROJECT_READER", name: "Projekt Megtekintés"},
    {id: "PROJECT_EDITOR", name: "Projekt Szerkesztés"},
    {id: "PROJECT_TASK_READER", name: "Projekt Feladat Megtekintés"},
    {id: "PROJECT_TASK_EDITOR", name: "Projekt Feladat Szerkesztés"},
    {id: "GLOBAL_PAYMENT_MODIFIER_READER", name: "Globális Fizetési Módósító Megtekintés"},
    {id: "GLOBAL_PAYMENT_MODIFIER_EDITOR", name: "Globális Fizetési Módósító Szerkesztés"},
    {id: "TASK_LOG_READER", name: "Munkaidő Bejegyzés Megtekintés"},
    {id: "TASK_LOG_EDITOR", name: "Munkaidő Bejegyzés Szerkesztés"},
    {id: "TASK_TYPE_EDITOR", name: "Feladatkör Szerkesztés"},
    {id: "VEHICLE_READER", name: "Számla Megtekintés"},
    {id: "VEHICLE_EDITOR", name: "Jármű Szerkesztés"},
    {id: "INVOICE_READER", name: "Számla Megtekintés"},
    {id: "INVOICE_EDITOR", name: "Számla Szerkesztés"},
    {id: "TOOL_READER", name: "Tudásbázis Megtekintés"},
    {id: "TOOL_EDITOR", name: "Tudásbázis Szerkesztés"},
    {id: "PRODUCT_READER", name: "Raktár Megtekintés"},
    {id: "PRODUCT_EDITOR", name: "Raktár Szerkesztés"},
    {id: "PRODUCT_ADMINISTRATOR", name: "Raktár Adminisztrátor"},
    {id: "STORAGE_LOG_READER", name: "Raktár Történet Megtekintés"},
    {id: "NOTE_READER", name: "Jegyzet Megtekintés"},
    {id: "NOTE_EDITOR", name: "Jegyzet Szerkesztés"},
    {id: "USER_READER", name: "Felhasználó Megtekintés"},
    {id: "USER_EDITOR", name: "Felhasználó Szerkesztés"},
    {id: "PAYROLL_READER", name: "Bérjegyzék Megtekintés"},
    {id: "PAYROLL_EDITOR", name: "Bérjegyzék Szerkesztés"},
    {id: "ROLE_MATRIX_READER", name: "Jogosultság Mátrix Megtekintés"},
    {id: "ROLE_MATRIX_EDITOR", name: "Jogosultság Mátrix Szerkesztés"},
    {id: "TASK_TYPE_READER", name: "Feladatkör Megtekintés"},
    {id: "CALENDAR_READER", name: "Naptár Megtekintés"},
    {id: "CALENDAR_EDITOR", name: "Naptár Szerkesztés"},
    {id: "TASK_READER", name: "Feladat Megtekintés"},
    {id: "TASK_EDITOR", name: "Feladat Szerkesztés"},
    {id: "PRODUCT_PROJECT_READER", name: "Termék Projekt Megtekintés"},
    {id: "PRODUCT_PROJECT_EDITOR", name: "Termék Projekt Szerkesztés"},
];

export default function Permissions() {

    useTitle([{name: 'Jogosultsági Mátrix'}])

    const [roles, setRoles] = useState([]);
    const [changed, setChanged] = useState(false);
    const {sendAlertMessage} = useSnackbar()
    const [waitingForServer, setWaitingForServer] = useState(false);


    useEffect(() => {
        retrieveRoles()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const retrieveRoles = () => {
        roleService.findAll()
            .then(response => {
                setChanged(false)
                setRoles(response)
            })
            .catch((error) => sendAlertMessage(error?.message || 'Jogosultságok lekérése sikertelen', 'error'))
    }

    const updateMatrix = () => {
        setWaitingForServer(true)
        const request = {
            matrix: roles.reduce((acc, role) => {
                acc[role.name] = role.permissions;
                return acc;
            }, {})
        }
        roleService.updateMatrix(request)
            .then(() => sendAlertMessage('Jogosultsági mátrix sikeresen frissítve'))
            .catch((error) => sendAlertMessage(error?.message || 'Jogosultságok frissítése sikertelen', 'error'))
            .finally(() => {
                setWaitingForServer(false)
                retrieveRoles()
            })
    }

    const handlePermissionChange = (roleId, permission, isChecked) => {
        setChanged(true)
        setRoles((prevRoles) =>
            prevRoles.map((role) =>
                role.id === roleId ? {
                    ...role,
                    permissions: isChecked ? [...role.permissions, permission] : role.permissions.filter((perm) => perm !== permission),
                } : role
            )
        );
    };

    rows.sort((a, b) => a.name.localeCompare(b.name));
    return (
        <>
            <Paper sx={{width: '100%', overflow: 'hidden'}}>
                <TableContainer>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{padding: "0px", background: "gray"}}></TableCell>
                                {roles.map(role => ROLES[Object.keys(ROLES).find(k => k === role.name)]).map((value, index) => (
                                    <TableCell key={index} align="center" sx={{
                                        padding: "5px",
                                        fontWeight: "bold",
                                        background: "gray",
                                        color: "white"
                                    }}>
                                        {value}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => (
                                <TableRow key={index} hover>
                                    <TableCell align="right" sx={{
                                        padding: "0px 5px 0px 5px",
                                        width: "300px",
                                        borderRight: "1px solid gray"
                                    }}>{row.name}</TableCell>
                                    {roles.map(((role, index) => (
                                        <TableCell key={index} align="center" sx={{padding: "0px"}}>
                                            <Checkbox
                                                variant="outlined"
                                                size="medium"
                                                name="lunchBreak"
                                                onChange={(e) => handlePermissionChange(role.id, row.id, e.target.checked)}
                                                checked={role.permissions.find(p => p === row.id) != null}
                                                sx={{padding: "0px"}}
                                            />
                                        </TableCell>
                                    )))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                {waitingForServer ? <CircularProgress sx={{margin: "-5px"}}/> :
                    <div style={{textAlign: "right"}}>
                        <Button variant="contained" color="success" onClick={() => updateMatrix()} sx={{margin: '8px', width: "200px"}} disabled={!changed}>
                            Mentés
                        </Button>
                    </div>}
            </Paper>
        </>
    );
}
